import { render, staticRenderFns } from "./SettingsMenu.vue?vue&type=template&id=1ff37cd0&scoped=true"
import script from "./SettingsMenu.vue?vue&type=script&lang=js"
export * from "./SettingsMenu.vue?vue&type=script&lang=js"
import style0 from "./SettingsMenu.vue?vue&type=style&index=0&id=1ff37cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff37cd0",
  null
  
)

export default component.exports